import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaHome } from 'react-icons/fa';

function Footer() {
  return (
    <footer>
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-section">
            <h3>Fitness Health Blog</h3>
            <p>Your trusted partner in health and wellness. We provide premium quality fitness products to support your journey to a healthier lifestyle.</p>
          </div>
          
          <div className="footer-section">
            <h3>Quick Links</h3>
            <Link to="/">Home</Link>
            <Link to="/about">About Us</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/cart">Shopping Cart</Link>
          </div>
          
          <div className="footer-section">
            <h3>Contact Information</h3>
            <p><FaHome /> Studio 52 Kennedy Grove South Wendy NW2 2SH, United Kingdom</p>
            <p><FaPhone /> +448648285526</p>
            <p><FaEnvelope /> info@topfitnessproducts.com</p>
            <p>Company Registration: 27135609</p>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="policy-links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-conditions">Terms and Conditions</Link>
            <Link to="/refund-policy">Refund Policy</Link>
          </div>
          <p>Copyright 2025 Fitness Health Blog. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;